<template>
  <div>
    <div class="!isLoading && w-100">
      <div class="row mb-3">
        <div class="col-24">
          <div v-html="value.rate.rateGroupRate.BreakfastIntro"></div>
        </div>
      </div>

      <!--<div class="row mb-3">
                <div class="col-24">
                    <div class="sit-together">
                        <p>
                            Please advise if you’d like to join with any other tables for breakfast or dinner, including preferred dates if your booking is for more than one night.

                        </p>
                    </div>
                </div>
            </div>-->

      <div class="row mb-3" v-if="menus.length">
        <div class="col-24">
          <ul class="menus row">
            <li
              class="col-24 col-xl"
              v-for="(restaurant, index) in menus"
              v-bind:key="index"
            >
              <a v-bind:href="restaurant.MenuLink" target="_blank">
                {{ restaurant.DisplayName }} sample menu
              </a>
            </li>
          </ul>
        </div>
      </div>

      <Form @submit="onSubmit" :validation-schema="schema">
        <div v-if="availability" class="times-wrapper mt-5">
          <div
            class="bg-white p-3 mb-3"
            v-for="(dayAvailability, index) in availability"
            v-bind:key="index"
          >
            <div class="row form-group">
              <div class="col-xl-8 mb-3 mb-xl-0">
                <span class="time-date-day">{{
                  formatDateLine1(dayAvailability.Date)
                }}</span>
                <span class="time-date-year">{{
                  foramtDateLine2(dayAvailability.Date)
                }}</span>
              </div>

              <div class="col-xl-16">
                <div class="row">
                  <div class="col-24 col-xl-12 mb-3 mb-xl-0">
                    <Field
                      v-bind:name="`restaurants[${index}].date`"
                      v-bind:value="dayAvailability.Date"
                      type="hidden"
                    ></Field>

                    <div
                      v-if="dayAvailability.RestaurantAvailabilities.length > 1"
                    >
                      <Field
                        v-bind:name="`restaurants[${index}].restaurant`"
                        class="form-select"
                        as="select"
                        v-on:change="onSelection(dayAvailability, $event)"
                      >
                        <option value="" selected disabled>
                          Please select
                        </option>
                        <option
                          v-for="r in dayAvailability.RestaurantAvailabilities"
                          v-bind:key="r.RestaurantId"
                          v-bind:value="r.RestaurantId"
                        >
                          {{ getRestaurantName(r.RestaurantId) }}
                        </option>
                      </Field>
                    </div>
                    <div class="v-else">
                      <Field
                        v-bind:name="`restaurants[${index}].restaurant`"
                        type="hidden"
                        v-bind:value="
                          dayAvailability.RestaurantAvailabilities[0]
                            .RestaurantId
                        "
                      ></Field>
                    </div>

                    <ErrorMessage
                      v-bind:name="`restaurants[${index}].restaurant`"
                      class="error-message"
                    />
                  </div>

                  <div v-if="checkNoAvailability(dayAvailability)">
                    <Field
                      v-bind:name="`restaurants[${index}].isAvailable`"
                      type="hidden"
                      v-bind:value="false"
                    />

                    <p style="text-align: left">
                      Unfortunately at present there is no availability for your
                      selected dates. Please complete your preferred dining
                      times in the comments box on the Guest Details screen and
                      the team will be in touch to confirm.
                    </p>
                  </div>

                  <div
                    class="col-24 col-xl-12"
                    v-else-if="
                      dayAvailability.RestaurantAvailabilities.length > 1
                    "
                  >
                    <div
                      v-if="
                        dayAvailability.RestaurantAvailabilities.length > 1 &&
                        getSelectedRestaurantTimeSlots(dayAvailability).length >
                          0
                      "
                    >
                      <Field
                        v-bind:name="`restaurants[${index}].isAvailable`"
                        type="hidden"
                        v-bind:value="true"
                      />

                      <Field
                        v-bind:name="`restaurants[${index}].timeslot`"
                        class="form-select"
                        as="select"
                      >
                        <option value="" selected disabled>
                          Please select
                        </option>
                        <option
                          v-bind:key="ts.TimeSlot"
                          v-bind:value="ts.TimeSlot"
                          v-for="ts in getSelectedRestaurantTimeSlots(
                            dayAvailability
                          )"
                        >
                          {{
                            ts.TimeSlot.substring(11, ts.TimeSlot.length - 3)
                          }}
                        </option>
                      </Field>
                      <ErrorMessage
                        v-bind:name="`restaurants[${index}].timeslot`"
                        class="error-message"
                      />
                    </div>
                  </div>
                  <div v-else>
                    <div
                      v-if="getFirstRestaruantTimeSlots(dayAvailability).length"
                    >
                      <Field
                        v-bind:name="`restaurants[${index}].isAvailable`"
                        type="hidden"
                        v-bind:value="true"
                      />

                      <Field
                        v-bind:name="`restaurants[${index}].timeslot`"
                        class="form-select"
                        as="select"
                      >
                        <option value="" selected disabled>
                          Please select
                        </option>
                        <option
                          v-bind:key="ts.TimeSlot"
                          v-bind:value="ts.TimeSlot"
                          v-for="ts in getFirstRestaruantTimeSlots(
                            dayAvailability
                          )"
                        >
                          {{
                            ts.TimeSlot.substring(11, ts.TimeSlot.length - 3)
                          }}
                        </option>
                      </Field>
                      <ErrorMessage
                        v-bind:name="`restaurants[${index}].timeslot`"
                        class="error-message"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-8">
          <div class="col-12 d-flex justify-content-start">
            <button
              class="btn btn--transparent btn--back"
              type="button"
              v-on:click="onClose()"
            >
              Close
            </button>
          </div>

          <div class="col-12 d-flex justify-content-end">
            <button class="btn btn--slate-blue btn--continue">Done</button>
          </div>
        </div>
      </Form>
    </div>

    <div
      v-if="isLoading"
      class="position-relative d-flex justify-content-center"
    >
      <loader></loader>
    </div>
  </div>
</template>

<script>
import { store } from "../store/index";
import Loader from "@/shared/components/Loader.vue";
import { Field, Form, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import moment from "moment";

export default {
  name: "Breakfastvailability",
  props: {
    value: Object,
    occupancy: Number,
  },
  components: {
    Loader,
    Field,
    Form,
    ErrorMessage,
  },
  computed: {
    leg() {
      return this.value.leg;
    },
    session() {
      return store.getters.session;
    },
    search() {
      return store.getters.search;
    },
    restaurants() {
      return this.value.rate.rateGroupRate.BreakfastRestaurants;
    },
    menus() {
      let menus = [];

      for (let ri = 0; ri < this.restaurants.length; ri++) {
        let restaurant = this.restaurants[ri];
        if (restaurant.MenuLink != null && restaurant.MenuLink.length) {
          menus.push({
            DisplayName: restaurant.DisplayName,
            MenuLink: restaurant.MenuLink,
          });
        }
      }

      return menus;
    },
  },
  data() {
    const schema = yup.object().shape({
      restaurants: yup.array().of(
        yup.object().shape({
          date: yup.string().required().label("Date"),
          restaurant: yup.string().required().label("Restaurant"),
          isAvailable: yup.string().required(),
          //timeslot: yup.string().required("A time is required")
          timeslot: yup.string().when("isAvailable", {
            is: true,
            then: yup.string().required("A time is required"),
          }),
        })
      ),
    });

    return {
      schema,
      availability: null,
      isLoading: false,
      selectedTimeslot: null,
    };
  },
  mounted() {
    this.isLoading = true;
    var restuarantIds = this.restaurants.map((item) => item.RestaurantId);
    let payload = {
      Guests: this.occupancy,
      ArrivalDate: moment(this.search.arrivalDate)
        .add("days", 1)
        .format("YYYY-MM-DD"),
      NumberOfNights: this.search.numberOfNights,
      Restaurants: restuarantIds,
      Sitting: 0,
    };

    store.dispatch("fetchBreakfastAvailability", payload).then((t) => {
      this.availability = t;
      this.isLoading = false;
    });
  },
  methods: {
    onClose() {
      this.$parent.$emit("close");
    },

    onSubmit(values) {
      var restaurantsBookings = values.restaurants.filter(
        (item) => item.isAvailable
      );

      var payload = {
        leg: this.leg,
        restaurantBookings: values.restaurants,
        hasUnavailable: restaurantsBookings.length != values.restaurants.length,
      };

      store.dispatch("selectBreakfast", payload).then(() => {
        this.$parent.$emit("close");
      });
    },

    getRestaurantName(restaurantId) {
      return this.restaurants.find((item) => item.RestaurantId == restaurantId)
        .DisplayName;
    },
    onSelection(dayAvailability, event) {
      for (
        let i = 0;
        i < dayAvailability.RestaurantAvailabilities.length;
        i++
      ) {
        let restaurantAvailability =
          dayAvailability.RestaurantAvailabilities[i];
        restaurantAvailability.isSelected = false;
      }

      let restaurantAvailability =
        dayAvailability.RestaurantAvailabilities.find(
          (item) => item.RestaurantId == event.target.value
        );
      restaurantAvailability.isSelected = true;
    },
    onTimeslotSelection(dayAvailabilty, event) {
      let timeslots = this.getSelectedRestaurantTimeSlots(dayAvailabilty);

      for (var ti = 0; ti < timeslots.length; ti++) {
        var timeslot = timeslots[ti];
        timeslot.isSelected = timeslot.TimeSlot == event.target.value;
      }
    },
    getFirstRestaruantTimeSlots(dayAvailability) {
      let restaurantAvailability = dayAvailability.RestaurantAvailabilities[0];
      if (restaurantAvailability == null) {
        return [];
      }

      return restaurantAvailability.Availability.TimeSlots;
    },
    getSelectedRestaurantTimeSlots(dayAvailability) {
      let restaurantAvailability =
        dayAvailability.RestaurantAvailabilities.find(
          (item) => item.isSelected
        );
      if (restaurantAvailability == null) {
        return [];
      }

      return restaurantAvailability.Availability.TimeSlots;
    },
    formatDateLine1(date) {
      return moment(date).format("dddd Do");
    },
    foramtDateLine2(date) {
      return moment(date).format("MMMM YYYY");
    },
    checkNoAvailability(dayAvailability) {
      let result =
        dayAvailability.RestaurantAvailabilities == null ||
        dayAvailability.RestaurantAvailabilities.length < 1 ||
        dayAvailability.RestaurantAvailabilities.filter(
          (item) =>
            item.Availability == null ||
            item.Availability.TimeSlots == null ||
            item.Availability.TimeSlots.length < 1
        ).length > 0;

      return result;
    },
  },
};
</script>

<style scoped>
.times-wrapper {
  margin: 0 auto;
  width: 100%;
}

.time-date-day,
.time-date-year {
  display: block;
  width: 100%;
  font-size: 14px;
  text-transform: uppercase;
  text-align: left;
}

.time-date-day {
  font-weight: bold;
}

.time-date-year {
  font-weight: 400;
}

.sit-together {
  background-color: rgba(161, 143, 91, 0.2);
  padding: 20px 20px 20px 55px;
  text-align: left;
  font-size: 16px;
  font-family: Montserrat;
  background-repeat: no-repeat;
  background-position: 20px 20px;
  background-size: 26px 26px;
  background-image: url("@/assets/img/booking/exclamation.svg");
}

.sit-together p {
  margin-bottom: 0;
}

.menus {
  display: flex;
  list-style: none;
  justify-content: center;
  height: 100%;
}

.menus li {
  align-items: center;
  display: flex;
  margin: 5px;
}

.menus li a {
  font-size: 14px;
  height: 28px;
  line-height: 28px;
  font-family: Montserrat;
  text-decoration: underline;
  background-repeat: no-repeat;
  display: inline-block;
  padding-left: 30px;
  background-position: left center;
  background-size: 18px 25px;
  background-image: url("@/assets/img/booking/menu.svg");
}

.error-message {
  text-align: left;
}
</style>
